module.exports = __webpack_public_path__ + "static/img/wfs.954dd989.svg";